import { Api, $, h, toast } from './api';
import { ruleCard } from './cardui';
import { BOT_TEAMS, compileCar, compileTeam, strangerTeams } from '../shared/personas';
import { CLASS_TRAIN, PLANS, checkTeam, planBots, teamPrint, trainSeeds, trainTeam, type GenPoint, type RunGames, type TrainPlan } from '../shared/classtrain';
import { MAPS, getMap } from '../shared/map';
import type { CompiledTeam } from '../shared/defs';
import { Player, matchSummary } from './replay';
import { SimPool } from './simpool';
import { drawRates, seriesOf } from './chart';

const api = new Api();
const player = new Player({ mySide: null, fxToggle: true, hint: '开赛后，点表格里的格子看那一对的回放' });
$('#player').append(player.el);
let view: any = null;
const KEY = 'arena.teacher';
const BOTS = CLASS_TRAIN.bots.map((k) => ({ key: k, name: BOT_TEAMS[k].name, team: compileTeam(BOT_TEAMS[k]) }));
const bot = (k: string) => BOTS.find((b) => b.key === k)!;
const short = (n: string) => n.replace('机器人·', '');
const pct = (x: number) => `${Math.round(x * 100)}%`;
const clock = (t: number) => new Date(t).toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' });
// ?gens=10 trains fewer generations, for a quick rehearsal (the champion then differs from the full run)
const GENS = Math.max(1, Number(new URLSearchParams(location.search).get('gens')) || CLASS_TRAIN.generations);

api.onStatus = (ok) => { $('#conn').textContent = ok ? '' : '⚠ 连接断了，正在重连…'; };
api.onReconnect = () => { const s = saved(); if (s) attach(s.code, s.token); };
api.onPush = (m) => { if (['roster', 'round', 'beats', 'screen'].includes(m.t)) refresh(); };
const saved = () => { try { return JSON.parse(localStorage.getItem(KEY) || 'null'); } catch { return null; } };

(async () => {
  const s = saved();
  if (s) { try { await attach(s.code, s.token); return; } catch { /* fallthrough */ } }
  $('#start').classList.remove('hidden');
})();

async function attach(code: string, token: string) {
  view = await api.call('teacher.attach', { code, token });
  localStorage.setItem(KEY, JSON.stringify({ code, token }));
  $('#start').classList.add('hidden');
  $('#app').classList.remove('hidden');
  const kidUrl = `${location.origin}/kid?room=${code}`;
  $('#roomInfo').innerHTML = '';
  $('#roomInfo').append(h('span', { class: 'roomcode' }, `房间号 ${code}`),
    h('span', { class: 'muted small' }, ` 学生打开 ${kidUrl}　`),
    h('button', { class: 'btn small', onclick: (e: any) => { e.target.textContent = `口令 ${token}`; } }, '显示老师口令'),
    h('a', { href: `/screen?room=${code}`, target: '_blank', class: 'btn small' }, '打开大屏'),
    h('a', { href: '/rules', target: '_blank', class: 'btn small', id: 'rulesLink' }, '比赛规则'),
    h('label', { class: 'small mappick' }, '地图 ', h('select', { id: 'mapSel', onchange: (e: any) => pickMap(e.target) },
      ...Object.values(MAPS).map((m) => h('option', { value: m.id, title: m.blurb }, m.name)))),
    h('button', { class: 'btn small', onclick: () => { localStorage.removeItem(KEY); location.reload(); } }, '换房间'));
  pickSeed();
  render();
}

$('#createBtn').onclick = async () => {
  try { const r = await api.call('teacher.create'); await attach(r.code, r.token); } catch (e: any) { toast(e.message, 'error'); }
};
$('#attachBtn').onclick = async () => {
  try { await attach(($('#code') as HTMLInputElement).value.trim(), ($('#token') as HTMLInputElement).value.trim()); } catch (e: any) { toast(e.message, 'error'); }
};

async function refresh() { try { view = await api.call('teacher.state'); render(); } catch { /* ignore */ } }

// The teacher switches the whole room to another arena (kids' teams carry over; the champion stays with its map).
async function pickMap(sel: HTMLSelectElement) {
  const next = getMap(sel.value);
  if (!confirm(`整个房间换到「${next.name}」？\n${next.blurb}\n\n学生的队都留着。全班冠军只在它练过的地图上算数，“打败冠军的打法”会清空。`)) { sel.value = view.map; return; }
  try { view = await api.call('teacher.map', { map: next.id }); pickSeed(); render(); }
  catch (e: any) { sel.value = view.map; toast(e.message, 'error'); }
}

function render() {
  ($('#mapSel') as HTMLSelectElement).value = view.map;
  ($('#mapSel') as HTMLSelectElement).disabled = !!running;
  $('#rulesLink').setAttribute('href', `/rules?map=${view.map}`);
  if (player.mapId !== view.map) player.mapId = view.map; // empty arena shows the room's map
  renderRoster();
  renderScreen();
  renderTrainings();
  renderRounds();
  ($('#v2Btn') as HTMLButtonElement).disabled = !!running || !view.champion;
}

function renderRoster() {
  $('#count').textContent = `${view.kids.length} 人`;
  const tb = $('#roster');
  tb.innerHTML = '';
  for (const k of view.kids) {
    const vc = k.vsChampion;
    tb.append(h('tr', {},
      h('td', {}, h('a', { href: '#', onclick: (e: Event) => { e.preventDefault(); showKid(k.id); } }, k.name)),
      h('td', {}, String(k.versions)), h('td', {}, k.locked != null ? `第${k.locked}版` : '—'),
      h('td', { class: vc.played && !vc.won ? 'warnc' : '' }, vc.played ? `赢 ${vc.won} / ${vc.played}${k.beat ? ' ✓' : ''}` : k.beat ? '✓' : '—'),
      h('td', { class: 'small' }, k.last ? `${k.last.car + 1}号车：“${k.last.say}”` : ''),
      h('td', {}, h('button', { class: 'btn tiny', title: '进错房间的学生：移出这个房间', onclick: () => removeKid(k) }, '移出'))));
  }
}

async function removeKid(k: any) {
  if (!confirm(`把「${k.name}」移出这个房间？这个学生写的队伍会删掉，页面会回到输入房间号。`)) return;
  try { view = await api.call('teacher.kidRemove', { id: k.id }); render(); } catch (e: any) { toast(e.message, 'error'); }
}

// ---------- big screen ----------
const SCREENS: [string, string][] = [['rules', '比赛规则'], ['round', '比赛焦点赛'], ['results', '比赛结果'], ['train', '训练曲线'], ['champion', '冠军规则卡'], ['beats', '打败冠军的打法']];
function renderScreen() {
  const box = $('#screenBtns');
  box.innerHTML = '';
  const cur = view.screen?.mode ?? 'round';
  const pick = cur === 'round' ? view.screen?.pick : null;
  for (const [mode, label] of SCREENS) {
    box.append(h('button', { class: `chip ${cur === mode && !pick ? 'on' : ''}`, onclick: () => setScreen({ mode }) }, label));
  }
  if (cur === 'replay') box.append(h('span', { class: 'muted small' }, '　大屏正在放训练回放'));
  if (cur === 'kid') {
    const [a, b] = view.screen.teams.map((t: any) => short(t.name));
    box.append(h('span', { class: 'muted small' }, `　大屏正在放 ${a} 的视角：${a} 对 ${b}`));
  }
  renderPov();
  if (pick) {
    const r = view.rounds.find((x: any) => x.n === pick.n);
    const name = (k: string) => short(r?.entries.find((e: any) => e.key === k)?.name ?? '');
    box.append(h('span', { class: 'muted small' }, `　大屏正在放第 ${pick.n} 轮：${name(pick.a)} 对 ${name(pick.b)}`));
  }
  // how the big screen plays its game: rule cards, speed, camera, and play it again from the start
  const ctl = view.screenCtl ?? { rules: false, speed: 1, view: 'director' };
  const sc = $('#screenCtl');
  sc.innerHTML = '';
  const chip = (label: string, on: boolean, c: object, title = '') => h('button', { class: `chip ${on ? 'on' : ''}`, title, onclick: () => call('teacher.screenCtl', { ctl: c }) }, label);
  sc.append(h('span', { class: 'muted' }, '放比赛时：'),
    chip(ctl.rules ? '规则卡：显示' : '规则卡：不显示', ctl.rules, { rules: !ctl.rules }, '在大屏两边显示双方的规则卡，正在用的那条会亮'),
    h('span', { class: 'muted' }, '　速度'), ...[1, 2, 4].map((x) => chip(`${x}倍`, ctl.speed === x, { speed: x })),
    h('span', { class: 'muted' }, '　视角'), ...[['director', '导演'], ['tactical', '全景'], ['top', '俯视'], ['follow', '跟随']].map(([v, l]) => chip(l, ctl.view === v, { view: v })),
    h('span', { class: 'muted' }, '　'), h('button', { class: 'btn tiny', title: '大屏上正在放的这一局，从头再放一遍', onclick: () => call('teacher.screenCtl', { ctl: { restart: true } }) }, '↺ 从头再放'));
  const bl = $('#beatList');
  bl.innerHTML = '';
  if (view.champion) {
    bl.append(h('div', { class: 'muted' }, view.beats.length ? '打败冠军的打法（测试 30 局赢过冠军的队，大屏和学生页都能看到）：' : '还没有人用“测试 30 局（只打冠军）”赢过冠军。'));
    for (const b of view.beats) {
      bl.append(h('div', { class: 'row' }, `${b.name}：赢 ${b.wdl[0]} 平 ${b.wdl[1]} 输 ${b.wdl[2]}`,
        h('button', { class: 'btn tiny', title: '从列表里拿掉', onclick: () => call('teacher.beatDelete', { id: b.id }) }, '拿掉')));
    }
  }
}

// 某个小朋友的视角: pick a kid and an opponent, and a fresh game goes up on the big screen with that
// kid's team on blue, their cars marked and the camera staying with them. Their current teams, as
// they are right now; pressing again plays a new game.
const pov = { kid: '', opp: '' };
function renderPov() {
  const box = $('#povRow');
  box.innerHTML = '';
  if (!view.kids.length) { box.append(h('span', { class: 'muted' }, '某个小朋友的视角：学生进来以后可以选。')); return; }
  if (!view.kids.some((k: any) => k.id === pov.kid)) pov.kid = view.kids[0].id;
  const opps: [string, string][] = [
    ...view.kids.filter((k: any) => k.id !== pov.kid).map((k: any): [string, string] => [`kid:${k.id}`, k.name]),
    ...(view.champion ? [['champion', '冠军'] as [string, string]] : []),
    ...BOTS.map((b): [string, string] => [`bot:${b.key}`, b.name]),
  ];
  if (!opps.some(([k]) => k === pov.opp)) pov.opp = opps[0][0];
  const kidSel = h('select', { onchange: (e: any) => { pov.kid = e.target.value; renderPov(); } },
    ...view.kids.map((k: any) => h('option', { value: k.id, selected: k.id === pov.kid }, k.name)));
  const oppSel = h('select', { onchange: (e: any) => { pov.opp = e.target.value; } },
    ...opps.map(([k, n]) => h('option', { value: k, selected: k === pov.opp }, n)));
  box.append(h('span', { class: 'muted' }, '某个小朋友的视角：'), kidSel, h('span', { class: 'muted' }, '对'), oppSel,
    h('button', { class: 'btn tiny primary', title: '用双方现在的队打一局新的，从这个小朋友那一边看', onclick: () => setScreen({ mode: 'kid', kidId: pov.kid, opp: pov.opp }) }, '放到大屏'));
}

async function setScreen(screen: any) {
  // "训练曲线" with no run going shows the current champion's training (or the newest one)
  if (screen.mode === 'train' && !screen.id && !running) screen.id = view.champion ?? view.trainings[view.trainings.length - 1]?.id;
  await call('teacher.screen', { screen });
}

async function call(t: string, args: object = {}) {
  try { view = await api.call(t, args); render(); } catch (e: any) { toast(e.message, 'error'); }
}

// ---------- the class training ----------
let pool: SimPool | null = null;
let running: { stop: boolean } | null = null;
const seedBox = $('#seed') as HTMLInputElement, planSel = $('#plan') as HTMLSelectElement;
seedBox.value = String(CLASS_TRAIN.seeds.normal);
// the seed picked before class for this plan on the room's map, and a warning where the demo doesn't work
function pickSeed() {
  const t = trainSeeds(view?.map), plan = planSel.value as TrainPlan;
  seedBox.value = String(t.seeds[plan]);
  $('#planNote').textContent = t.noDemo?.[plan] ?? '';
}
planSel.onchange = pickSeed;
$('#trainBtn').onclick = () => train('v1');
$('#v2Btn').onclick = () => train('v2');
$('#stopBtn').onclick = () => { if (running) running.stop = true; };

function drawLive(curve: GenPoint[], opponents: string[], watched: number, gens: number) {
  drawRates($('#rates') as HTMLCanvasElement, seriesOf(curve, opponents, watched), gens);
}

async function train(kind: 'v1' | 'v2') {
  if (running) return;
  const bots = BOTS.map((b) => b.team), botNames = BOTS.map((b) => b.name);
  let plan = planSel.value as TrainPlan, seed = Math.max(0, Math.floor(Number(seedBox.value) || 0));
  const pb = planBots(plan); // 只跟全员冲旗练: the other bots are only watched
  let opponents = pb.train.map((k) => bot(k).team), watch = pb.watch.map((k) => bot(k).team);
  let names = [...pb.train, ...pb.watch].map((k) => bot(k).name), gens = GENS;
  let start: CompiledTeam[] | undefined, parent: any = null;
  if (kind === 'v2') {
    parent = view.trainings.find((t: any) => t.id === view.champion);
    if (!parent) { toast('先练出一个冠军', 'error'); return; }
    const cls: { name: string; team: CompiledTeam }[] = await api.call('teacher.classTeams');
    if (!cls.length) { toast('还没有学生的队', 'error'); return; }
    opponents = [...bots, ...cls.map((c) => c.team)];
    watch = [];
    names = [...botNames, ...cls.map((c) => c.name)];
    start = [parent.champion, ...bots];
    gens = Math.min(GENS, CLASS_TRAIN.v2Generations);
    plan = 'normal';
    seed = parent.seed;
  }
  pool ??= new SimPool();
  const map = view.map, p0 = pool;
  const run: RunGames = (games) => p0.run(games.map((g) => ({ ...g, map }))); // every game on the room's arena
  running = { stop: false };
  ($('#mapSel') as HTMLSelectElement).disabled = true;
  const btn = (kind === 'v1' ? $('#trainBtn') : $('#v2Btn')) as HTMLButtonElement;
  btn.disabled = true;
  ($('#v2Btn') as HTMLButtonElement).disabled = true;
  $('#stopBtn').classList.remove('hidden');
  $('#trainResult').innerHTML = '';
  const info = $('#trainInfo');
  const t0 = performance.now();
  const curve: GenPoint[] = [];
  const { mode, reward } = PLANS[plan];
  try {
    await api.call('teacher.trainStart', { kind, plan, mode, seed, gens, opponents: names });
    drawLive(curve, names, watch.length, gens);
    const out = await trainTeam({ seed, mode, reward, opponents, watch, start, generations: gens }, run, (p) => {
      curve.push(p);
      drawLive(curve, names, watch.length, gens);
      info.textContent = `第 ${p.gen} / ${gens} 代 · 已经打了 ${p.games.toLocaleString()} 局${reward === 'kills' ? ` · 每局打掉 ${p.kills.toFixed(1)} 辆车` : ''} · ${Math.round((performance.now() - t0) / 1000)} 秒 · ${pool!.size} 个线程`;
      api.call('teacher.trainTick', { point: p }).catch(() => {});
      return !running!.stop;
    });
    if (!out) { info.textContent = '停下了。'; await api.call('teacher.trainStop'); return; }
    info.textContent = `练完了，正在验收冠军…`;
    const check = await checkTeam(out.champion, [...opponents, ...watch], CLASS_TRAIN.checkGames, run);
    let compare;
    if (kind === 'v2') {
      const cls = opponents.slice(bots.length), strangers = strangerTeams(72, 4242).map(compileTeam);
      const [c1, c2, s1, s2] = [
        await checkTeam(parent.champion, cls, 20, run, 8_000_000), await checkTeam(out.champion, cls, 20, run, 8_000_000),
        await checkTeam(parent.champion, strangers, 10, run, 12_000_000), await checkTeam(out.champion, strangers, 10, run, 12_000_000),
      ];
      compare = { names: names.slice(bots.length), v1: c1.rates, v2: c2.rates, strangers: strangers.length, beatV1: s1.rates.filter((r) => r < 0.5).length, beatV2: s2.rates.filter((r) => r < 0.5).length };
    }
    const ms = Math.round(performance.now() - t0);
    const print = teamPrint(out.champion);
    const r = await api.call('teacher.trainSave', {
      training: { kind, parent: parent?.id, plan, seed, mode, map, gens, games: out.games, ms, opponents: names, curve: out.curve, snaps: out.snaps, champion: out.champion, check, print, compare },
    });
    view = r.state;
    info.textContent = `练完了：${gens} 代，${out.games.toLocaleString()} 局，用了 ${Math.round(ms / 1000)} 秒。`;
    const picked = trainSeeds(map), expected = kind === 'v1' && seed === picked.seeds[plan] && gens === CLASS_TRAIN.generations ? picked.prints[plan] : '';
    $('#trainResult').append(checkLine(names, check.rates, watch.length), plan === 'kills' ? killsLine(check.kills, check.scored) : '',
      expected ? h('div', { class: `small ${expected === print ? 'okc' : 'warnc'}` }, expected === print
        ? '✓ 和课前测好的冠军一模一样。'
        : '⚠ 这台电脑练出来的冠军和课前测好的不一样（换 Chrome 试试），课上可以直接放存好的训练。') : '',
      kind === 'v1' && plan === 'normal' && view.champion !== r.id
        ? h('div', { class: 'small muted' }, '换了种子：这次没有顶替全班的冠军。要用它，就在下面点“设为全班的冠军”。') : '');
    render();
  } catch (e: any) {
    toast('训练出错了：' + e.message, 'error');
    api.call('teacher.trainStop').catch(() => {});
    pool?.destroy();
    pool = null; // start with fresh workers next time
  } finally {
    running = null;
    ($('#mapSel') as HTMLSelectElement).disabled = false;
    btn.disabled = false;
    ($('#v2Btn') as HTMLButtonElement).disabled = !view.champion;
    $('#stopBtn').classList.add('hidden');
  }
}

// watched: the last this many bots were never trained against (只跟全员冲旗练)
function checkLine(names: string[], rates: number[], watched = 0) {
  const bots = rates.slice(0, 4);
  const all = bots.every((r) => r > 0.5);
  return h('div', { class: 'checkline' },
    h('span', {}, `验收（每个机器人新打 ${CLASS_TRAIN.checkGames} 局）：`),
    ...bots.map((r, j) => h('span', { class: r > 0.5 ? 'okc' : 'warnc' }, `${short(names[j])}${watched && j >= bots.length - watched ? '（没练过）' : ''} ${pct(r)}　`)),
    h('b', { class: all ? 'okc' : 'warnc' }, all ? '✓ 4 个机器人全赢' : '✗ 有打不过的机器人'));
}

const avg = (xs: number[]) => xs.reduce((a, b) => a + b, 0) / Math.max(1, xs.length);
function killsLine(kills: number[], scored: number[]) {
  return h('div', { class: 'small' }, `冠军平均每局打掉 ${avg(kills).toFixed(1)} 辆车，自己得 ${avg(scored).toFixed(1)} 分。`);
}

function renderTrainings() {
  const box = $('#trainings');
  box.innerHTML = '';
  if (!view.trainings.length) { box.append(h('p', { class: 'muted small' }, '还没有。练完会自动存在这个房间里，课上可以直接放。')); return; }
  for (const t of [...view.trainings].reverse()) {
    const isChamp = t.id === view.champion;
    const label = t.kind === 'v2' ? '第二版（跟全班的队练）' : PLANS[t.plan as TrainPlan]?.label ?? '';
    const opp = h('select', { class: 'small' }, ...BOTS.map((b) => h('option', { value: b.key }, short(b.name)))) as HTMLSelectElement;
    const last = t.snapGens[t.snapGens.length - 1];
    const snaps = t.snapGens.map((g: number) => h('button', { class: 'btn tiny', onclick: () => showSnap(t.id, g, opp.value) },
      g === last ? (t.kind === 'v2' ? '第二版冠军' : '冠军') : `第${g}代`));
    const card = h('div', { class: `trun ${isChamp ? 'champ' : ''}` },
      h('div', {}, isChamp ? h('span', { class: 'pill ok' }, '全班的冠军') : '',
        h('b', {}, ` ${clock(t.at)} · 种子 ${t.seed} · ${label}`), t.map !== view.map ? h('span', { class: 'pill' }, `在「${getMap(t.map).name}」上练的`) : '',
        h('span', { class: 'muted small' }, ` · ${t.gens} 代 · ${t.games.toLocaleString()} 局 · ${Math.round(t.ms / 1000)} 秒`)),
      checkLine(t.opponents, t.checkRates, t.watched), t.plan === 'kills' ? killsLine(t.checkKills, t.checkScored) : '',
      h('div', { class: 'row wrap small' }, '放到大屏：', ...snaps, '对', opp),
      h('div', { class: 'row wrap' },
        h('button', { class: 'btn tiny', onclick: () => setScreen({ mode: 'train', id: t.id }) }, '大屏看曲线'),
        h('button', { class: 'btn tiny', onclick: () => setScreen({ mode: 'champion', id: t.id }) }, '大屏看规则卡'),
        t.kind === 'v1' && (t.plan === 'normal' || t.plan === 'mean') && !isChamp && t.map === view.map
          ? h('button', { class: 'btn tiny', onclick: () => call('teacher.champion', { id: t.id }) }, '设为全班的冠军') : '',
        h('button', { class: 'btn tiny', onclick: () => showChampion(t) }, '看规则卡'),
        h('button', { class: 'btn tiny', onclick: () => { if (confirm('删掉这次训练？')) call('teacher.trainDelete', { id: t.id }); } }, '删除')));
    if (t.compare) card.append(compareTable(t.compare));
    box.append(card);
  }
}

function compareTable(c: any) {
  const table = h('table', { class: 'matrix' }, h('tr', {}, h('th', {}, '全班的队'), h('th', {}, '第一版赢它'), h('th', {}, '第二版赢它')));
  c.names.forEach((n: string, i: number) => table.append(h('tr', {}, h('th', {}, n),
    h('td', { class: c.v1[i] > 0.5 ? 'win' : 'loss' }, pct(c.v1[i])), h('td', { class: c.v2[i] > 0.5 ? 'win' : 'loss' }, pct(c.v2[i])))));
  const beats = (xs: number[]) => xs.filter((x) => x > 0.5).length;
  return h('div', { class: 'small' }, table,
    h('div', {}, `全班 ${c.names.length} 支队：第一版赢 ${beats(c.v1)} 支，第二版赢 ${beats(c.v2)} 支。`),
    h('div', {}, `没见过的 ${c.strangers} 支随机队里，能赢第一版的 ${c.beatV1} 支，能赢第二版的 ${c.beatV2} 支。`));
}

async function showSnap(id: string, gen: number, opp: string) {
  await call('teacher.screen', { screen: { mode: 'replay', id, gen, opp } });
  try {
    const d = await api.call('teacher.snapReplay', { id, gen, opp });
    $('#summary').textContent = `${d.title}　${matchSummary(d.result, d.result.replay.names)}（同样的对手打 ${d.games} 局：赢 ${d.record[0]} 平 ${d.record[1]} 输 ${d.record[2]}，这是其中典型的一局）`;
    player.load(d);
  } catch (e: any) { toast(e.message, 'error'); }
}

function showChampion(t: any) {
  const p = $('#kidPanel');
  p.classList.remove('hidden');
  p.innerHTML = '';
  p.append(h('h2', {}, `种子 ${t.seed} 练出来的${t.kind === 'v2' ? '第二版' : ''}冠军`));
  t.champion.forEach((c: any, i: number) => p.append(ruleCard(c.rules, c.params, { title: `${i + 1}号车` })));
  p.scrollIntoView({ behavior: 'smooth' });
}

// ---------- rounds ----------
const KIND_LABEL: Record<string, string> = { round: '', challenge: '（挑战 4 个机器人）', final: '（决赛）' };
function renderRounds() {
  const rb = $('#rounds');
  rb.innerHTML = '';
  for (const r of [...view.rounds].reverse()) {
    const n = r.entries.length;
    const wins = r.entries.map((_: any, i: number) => r.cells[i].filter((c: number[], j: number) => j !== i && c[0] > c[2]).length);
    const bots = r.entries.map((e: any, j: number) => (e.kind === 'bot' ? j : -1)).filter((j: number) => j >= 0);
    const allBots = (i: number) => r.kind === 'challenge' && bots.length === 4 && bots.every((j: number) => r.cells[i][j][0] > r.cells[i][j][2]);
    const table = h('table', { class: 'matrix' });
    table.append(h('tr', {}, h('th', {}, ''), ...r.entries.map((e: any) => h('th', {}, short(e.name)))));
    r.entries.forEach((e: any, i: number) => {
      table.append(h('tr', { class: e.kind === 'champion' ? 'champrow' : '' }, h('th', {}, `${short(e.name)}（胜${wins[i]}）${allBots(i) ? ' 🏆' : ''}`), ...r.entries.map((o: any, j: number) => i === j ? h('td', { class: 'self' }, '') :
        h('td', { class: r.cells[i][j][0] > r.cells[i][j][2] ? 'win' : r.cells[i][j][0] < r.cells[i][j][2] ? 'loss' : 'draw', title: '点一下看回放',
          onclick: () => replay(r.n, e.key, o.key) }, `${r.cells[i][j][0]}-${r.cells[i][j][1]}-${r.cells[i][j][2]}`))));
    });
    let note = '';
    if (r.kind === 'challenge') {
      const champs = r.entries.filter((e: any, i: number) => e.kind === 'told' && allBots(i)).map((e: any) => e.name);
      note = champs.length ? `4 个机器人全赢的：${champs.join('、')}` : '没有一支队把 4 个机器人全赢。';
    }
    const ci = r.entries.findIndex((e: any) => e.kind === 'champion');
    if (ci >= 0) note = `冠军赢了 ${wins[ci]} 个对手，排第 ${1 + wins.filter((w: number) => w > wins[ci]).length}（共 ${n} 支）。`;
    rb.append(h('h3', {}, `第 ${r.n} 轮${KIND_LABEL[r.kind] ?? ''}`), note ? h('p', { class: 'big' }, note) : '',
      h('p', { class: 'muted small' }, '格子里是 行 对 列：赢-平-输（20 局）'), table);
  }
}

async function replay(n: number, a: string, b: string, seed?: number) {
  try {
    const d = await api.call('teacher.replay', { n, a, b, seed });
    $('#summary').textContent = matchSummary(d.result, d.result.replay.names) + '　';
    // the exact game just loaded here (same seed), from the start, for the whole class
    $('#summary').append(h('button', { class: 'btn tiny', onclick: () => setScreen({ mode: 'round', pick: { n: d.n, a: d.a, b: d.b, seed: d.seed } }) }, '放到大屏'));
    player.load(d);
  } catch (e: any) { toast(e.message, 'error'); }
}

async function showKid(id: string) {
  const d = await api.call('teacher.kid', { kidId: id });
  const p = $('#kidPanel');
  p.classList.remove('hidden');
  p.innerHTML = '';
  p.append(h('h2', {}, `${d.name} 的队伍`));
  d.team.cars.forEach((c: any, i: number) => p.append(ruleCard(compileCar(c).rules, c.params, { title: `${i + 1}号车${c.kind === 'persona' ? '（机器人人设）' : ''}` })));
  p.append(h('h3', {}, '最近说的话'), ...d.log.slice().reverse().map((l: any) => h('div', { class: 'small' }, `${l.car + 1}号车：“${l.say}” → ${l.kind === 'edit' ? l.note : l.kind === 'clarify' ? '反问：' + l.note : '做不到：' + l.note}`)));
  p.scrollIntoView({ behavior: 'smooth' });
}

$('#roundBtn').onclick = () => runRound('round', $('#roundBtn') as HTMLButtonElement);
$('#challengeBtn').onclick = () => runRound('challenge', $('#challengeBtn') as HTMLButtonElement);
$('#finalBtn').onclick = () => runRound('final', $('#finalBtn') as HTMLButtonElement);
async function runRound(kind: string, btn: HTMLButtonElement) {
  const label = btn.textContent;
  btn.disabled = true;
  btn.textContent = '比赛中…'; // a challenge with 12 teams is 1,320 games: several seconds
  try {
    view = await api.call('teacher.round', { kind, champion: ($('#finalChamp') as HTMLInputElement).checked });
    render();
    const r = view.rounds[view.rounds.length - 1];
    if (r?.focus) replay(r.n, r.focus.a, r.focus.b, r.focus.seed); // the same game the big screen shows
  } catch (e: any) { toast(e.message, 'error'); } finally { btn.disabled = false; btn.textContent = label; }
}
